import { AxiosInstance } from 'axios';

import { InsightsAPIApiFactory } from '@cast/openapi';

import { AXIOS_CONFIGURATION } from '../constants';

export const SecurityInsightsApiAdapter = (client: AxiosInstance) => {
  const generatedApi = InsightsAPIApiFactory(AXIOS_CONFIGURATION, '', client);

  // prettier-ignore
  return {
    getAgentsStatuses: generatedApi.insightsAPIGetAgentsStatus,
    getAgentStatus: generatedApi.insightsAPIGetAgentStatus,
    getBestPracticeFilters: generatedApi.insightsAPIGetBestPracticesReportFilters,
    getBestPractices: generatedApi.insightsAPIGetBestPracticesReport,
    getBestPracticeChecks: generatedApi.insightsAPIGetBestPracticesReport,
    getBestPracticeCheck: generatedApi.insightsAPIGetBestPracticesCheckDetails,
    getBestPracticeComplianceStandards: generatedApi.insightsAPIGetComplianceStandards,
    getContainerImages: generatedApi.insightsAPIGetContainerImages,
    getContainerImagesFilters: generatedApi.insightsAPIGetContainerImagesFilters,
    getImageDetails: generatedApi.insightsAPIGetContainerImageDetails,
    getImageDetailsByManifestDigest: generatedApi.insightsAPIGetContainerImageDetailsByManifestDigest,
    getImageDigests: generatedApi.insightsAPIGetContainerImageDigests,
    getImageResources: generatedApi.insightsAPIGetContainerImageResources,
    getImageVulnerabilities: generatedApi.insightsAPIGetContainerImageVulnerabilities,
    getImagePackageVulnerabilityDetails: generatedApi.insightsAPIGetContainerImagePackageVulnerabilityDetails,
    getImagePackages: generatedApi.insightsAPIGetContainerImagePackages,
    changeImageExceptions: generatedApi.insightsAPIImageExceptionChanges,
    scheduleBestPracticesScan: generatedApi.insightsAPIScheduleBestPracticesScan,
    getCheckExceptions: generatedApi.insightsAPIGetCheckExceptions,
    saveCheckExceptions: generatedApi.insightsAPISaveCheckExceptions,
    getCheckExceptionsResources: generatedApi.insightsAPIPreviewExceptionGroupsResources,
    getSaveCheckExceptionsFilters: generatedApi.insightsAPISaveCheckExceptionsFilters,
    deleteImages: generatedApi.insightsAPIDeleteImages,
    getAttackPaths: generatedApi.insightsAPIGetAttackPaths,
    getAttackPathDetails: generatedApi.insightsAPIGetAttackPathDetails,
    getResourceDetails: generatedApi.insightsAPIGetResourceDetails,
    getBestPracticeCheckResources: generatedApi.insightsAPIGetCheckResources,
    getBestPracticeOverview: generatedApi.insightsAPIGetBestPracticesOverview,
    getImageSecurityOverview: generatedApi.insightsAPIGetImageSecurityOverview,
    getAttackPathsOverview: generatedApi.insightsAPIGetAttackPathsOverview,
    getWorkloads: generatedApi.insightsAPIListWorkloads,
    getClustersSettings: generatedApi.insightsAPIListClusterSecuritySettings,
    getSingleClusterSettings: generatedApi.insightsAPIGetClusterSecuritySettings,
    changeClusterSettings: generatedApi.insightsAPIConfigureClusterSecuritySettings,
    getVulnerabilitiesTrend: generatedApi.insightsAPIGetVulnerabilitiesTrend,
  };
};
